export default "__VITE_ASSET__BFSfoDHl__"